import { useTranslation } from '@/hooks/useTranslation';
import { Modal } from '@simplywallst/ui-core';
import { Dropdown } from '@/components/Dropdown';
import { useLocale } from '@/hooks/useLocale';
import { useState } from 'react';
import { isSupportedLocale } from '@/utils/locale';
import { useChangeLocale } from '@/components/Nav/DesktopTopbar/components/LanguageButton/hooks/useChangeLocale';
import { useUserLocale } from '@/hooks/useUserLocale';
import { useHotjar } from '@/hooks/useHotjar';

const localeOptions = [
  { label: 'English', option: 'en' },
  { label: 'Español', option: 'es' },
  { label: 'Deutsch', option: 'de' },
  { label: '한국인', option: 'ko' },
  { label: '日本語', option: 'ja' },
  { label: 'Français', option: 'fr' },
  { label: 'Italiano', option: 'it' },
  { label: 'Nederlands', option: 'nl' },
  { label: 'Türkçe', option: 'tr' },
  { label: 'Svenska', option: 'sv' },
];

export function LocaleModal({
  onConfirm,
  onClose,
}: {
  onConfirm: () => void;
  onClose: () => void;
}) {
  const t = useTranslation();
  const locale = useLocale();
  const { changeLocale } = useChangeLocale();
  const [selectedLocale, setSelectedLocale] = useState(locale);
  const [, setUserLocale] = useUserLocale();
  const [hotjar] = useHotjar();

  const handleSelect = (option: string) => {
    if (option === 'en' || isSupportedLocale(option)) {
      setSelectedLocale(option);
    }
    // never
  };
  return (
    <Modal
      title={t('app.topbar.nav.account.localeModal.title')}
      primaryLabel={t('app.topbar.nav.account.localeModal.save')}
      onPrimaryClick={() => {
        hotjar?.('event', 'locale_change');
        setUserLocale(selectedLocale);
        changeLocale(selectedLocale);
        onConfirm();
      }}
      secondaryLabel={t('app.topbar.nav.account.localeModal.cancel')}
      onSecondaryClick={onClose}
      removeWindowScroll={false}
    >
      <div>
        <Dropdown
          name="marketDropdown"
          options={localeOptions}
          value={selectedLocale}
          label={t('app.topbar.nav.account.localeModal.selectLabel')}
          styleType="standardReverse"
          onSelect={handleSelect}
        />
      </div>
    </Modal>
  );
}
